import {
  UpdateMatParam,
  CreateMatParam,
  Material,
  ListMatParam,
} from 'domains/matDomain';
import api from 'utils/api';
import { Paged } from 'domains/appDomain';
const matService = {
  getMatById: async (id: number) => {
    return api.get<Material>(`/api/materials/${id}`);
  },

  queryMats: async (param: ListMatParam) => {
    const pageNumber = param.page.currentPage - 1;
    const pageSize = param.page.pageSize || 20;
    return api.post<Paged<Material>>(
      `/api/materials/list?page=${pageNumber}&size=${pageSize}`,
      param.query
    );
  },

  queryBaseMats: async (param: ListMatParam) => {
    const pageNumber = param.page.currentPage - 1;
    const pageSize = param.page.pageSize || 10;
    return api.post<Paged<Material>>(
      `/api/materials/listBase?page=${pageNumber}&size=${pageSize}`,
      param.query
    );
  },

  updateMat: async (mat: UpdateMatParam) => {
    return api.put<Material>(`/api/materials/${mat.id}`, mat);
  },

  createMat: async (mat: CreateMatParam) => {
    return api.post<Material>(`/api/materials/create`, mat);
  },

  createFromBase: async (baseMaterialId: number) => {
    return api.post<Material>(
      `/api/materials/createFromBase?baseMaterialId=${baseMaterialId}`
    );
  },

  removeMat: async (matId: number) => {
    return api.delete<void>(`/api/materials/${matId}`);
  },

  removeAllMats: async () => {
    return api.delete<void>(`/api/materials/all`);
  },
};
export default matService;
